export const VIEW_TYPE = {
  OPEN: "open",
  ASSIGNED: "assigned",
  TICKET_STATUS: "ticket_status",
};
export const API_BASE_URL = "/ticket/get-ticket-list/";
export const OPEN_API_URL = "/ticket/get-all-ticket-list/";
export const TICKET_STATUS_API_URL = "/ticket/get-cv-pv-ticket-list/";

export const getTicketURL = (viewType) => {
  let apiUrl = "";
  switch (viewType) {
    case VIEW_TYPE.OPEN:
      apiUrl = OPEN_API_URL;
      break;
    case VIEW_TYPE.ASSIGNED:
      apiUrl = API_BASE_URL;

      break;
    case VIEW_TYPE.TICKET_STATUS:
      apiUrl = TICKET_STATUS_API_URL;
      break;
    default:
      apiUrl = API_BASE_URL;
  }

  return apiUrl;
};

export const getTicketTat = (tat) => {
  if (!tat) {
    return {
      colorCode: "Gray",
      hexCode: "#808080",
      description: "No Data",
      remainingDays: null,
    };
  }

  const expectedDate = new Date(tat.expected_date);
  const now = new Date();
  const diffTime = expectedDate.getTime() - now.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  let remainingDays = "";
  if (diffDays < 0) {
    remainingDays = `${Math.abs(diffDays)}-day overdue`;
  } else if (diffDays === 0) {
    remainingDays = "Due today";
  } else {
    remainingDays = `${diffDays}-day remaining`;
  }

  return {
    colorCode: tat.color_code,
    hexCode: tat.hex_code,
    description: tat.description,
    remainingDays,
  };
};

export const transformApiDataToRows = (apiData) => {
  if (!apiData || !apiData.data) return [];
  const rows = apiData.data.map((ticket) => ({
    ticketNumber: ticket.ticket_code,
    folio: ticket.folio_number,
    srn: ticket.srn,
    timeStamp: ticket.created_at,
    physicalDocumentReceived: ticket.physically_verified,
    document: ticket.type_of_security,
    status: ticket.status,
    id: ticket.id,
    companyName: ticket.company_name,
    shareholderName: ticket.shareholder_name,
    claimantName: ticket.claimant_name,
    numberOfShares: ticket.numbers_of_shares,
    faceValue: ticket.face_value,
    priority: ticket.priority,
    dueDate: ticket.due_date,
    createdAt: ticket.created_at,
    updatedOn: ticket.last_updated,
    ai_agent_status: ticket.ai_agent_status,
    reasonForReject: ticket.reject_reason,
    tat: getTicketTat(ticket.tat),
    updatedBy: ticket.updated_by?.full_name,
    remarks:
      Array.isArray(ticket.remarks) && ticket.remarks.length > 0
        ? ticket.remarks
            .sort((a, b) => b.id - a.id) // Sort by ID descending (greatest first)
            .find((r) => r.is_active)?.remark || ""
        : "",
    assignedPerformer: ticket.assigned_performer,
    assignedApprover: ticket.assigned_approver,
    assignedRta: ticket.assigned_rta,
    assignedPerformerName: ticket.assigned_performer?.full_name,
    assignedApproverName: ticket.assigned_approver?.full_name,
    assignedRtaName: ticket.assigned_rta?.full_name,
  }));

  rows.sort((a, b) => new Date(b.updatedOn) - new Date(a.updatedOn));
  return rows;
};
